<script context="module" lang="ts">
  import Icon from "../icons/Icon.svelte";
  export type AccountingIntegrationStatus = "success" | "failed" | "n/a";
  export function isValidAccountingIntegrationStatus(
    status: string
  ): status is AccountingIntegrationStatus {
    return ["success", "failed", "n/a"].includes(status);
  }
</script>

<script lang="ts">
  import TextNew from "../TextNew.svelte";
  export let status: AccountingIntegrationStatus;

  const iconsByStatus = {
    success: "statusSuccess",
    failed: "statusFailure",
    "n/a": null,
  } as const;
</script>

<div class="container">
  {#if status !== "n/a"}
    <div>
      <Icon name={iconsByStatus[status]} --w="16px" --h="16px" />
    </div>
  {/if}

  <div>
    <TextNew size="xs">
      {status === "n/a" ? "" : status}
    </TextNew>
  </div>
</div>

<style>
  .container {
    display: flex;
    align-items: center;
    gap: 6px;
  }
</style>
